import { createContext, useContext, useState, useEffect, useCallback } from "react"

const SidebarContext = createContext<{
  collapsed: boolean
  toggle: () => void
  isInitialized: boolean
}>({
  collapsed: true,
  toggle: () => {},
  isInitialized: false
})

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(true) // Always start collapsed
  const [isInitialized, setIsInitialized] = useState(false)

  // Initialize sidebar state on mount - always collapsed
  useEffect(() => {
    setIsInitialized(true)
  }, [])

  // Explicit click/tap toggle — the only way collapsed state changes.
  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [])

  // Auto-collapse on narrow/mobile screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setCollapsed(true)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <SidebarContext.Provider value={{ collapsed, toggle, isInitialized }}>
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar() {
  return useContext(SidebarContext)
}
